<template>
    <div class="details-padding">
        <div class="bg-white pt-5">
            <v-container grid-list-lg class="cust-mt">
                <v-layout row wrap pa-5 class="flex-wrap-reverse">
                    <v-flex xs12 sm12 md6 class="mobile-hide">
                        <div class="doctor">
                            <v-responsive>
                                <v-img height="500px"> </v-img>
                            </v-responsive>
                        </div>
                    </v-flex>
                    <div id="how-it-works"></div>
                    <v-flex xs12 sm12 md6 m-3>
                        <v-responsive>
                            <h2 class="font-bold">We need You!</h2>
                            <div class="font-normal pt-3 p-5 mb-2">
                                As a volunteer you will dedicate as much time as
                                you like to contribute to projects, product
                                ideas, engagement and research.
                                <br />
                                <br />
                                The Athena committee coordinates volunteers by
                                establishing communication between teams and
                                managing information flows, but won’t tell you
                                what to do.
                                <br />
                                <br />

                                Athena relies on lateral leadership exercised by
                                everybody. Volunteers are encouraged to actively
                                engage and be willing to lead initiatives on
                                various levels.
                            </div>
                            <v-btn
                                color="blue lighten-3"
                                to="/join"
                                large
                                class="mt-4 mx-0 font-normal text-none"
                                >Find out more</v-btn
                            >
                        </v-responsive>
                    </v-flex>
                    <v-flex xs12 sm12 md6 class="mobile-show">
                        <div class="doctor">
                            <v-responsive>
                                <v-img height="500px"> </v-img>
                            </v-responsive>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeDetails'
};
</script>

<style scoped>
@import '../assets/styles/main.css';

.doctor {
    background: url('../assets/img/Gruppe 17061.png');
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
}

@media only screen and (max-width: 768px) {
    .details-padding {
        margin-top: -140px;
    }
}
</style>
